export default __webpack_public_path__ + "static/media/why-its-time.d4dca9dd.jpg";